import { Component, computed, inject, OnInit, Renderer2, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AvatarComponent } from 'src/app/components/avatar/avatar.component';
import { TruncateDirective } from 'src/app/directives/truncate/truncate.directive';
import { BaseComponent } from 'src/app/components/_base/base.component';
import { Roles, Client } from 'src/app/types/identity';
import { RoutePath, Path } from 'src/app/shared/route';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './user-menu.component.html',
  standalone: true,
  selector: 'app-user-menu',
  imports: [
    RouterLink,
    AvatarComponent,
    TruncateDirective,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    TranslatePipe,
  ],
})
export class UserMenuComponent extends BaseComponent implements OnInit {
  settingPath = RoutePath.getPath(Path['setting/account/personal']).fullPath;
  billPath = RoutePath.getPath(Path['setting/billing/overview']).fullPath;

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly render = inject(Renderer2);

  readonly user = signal<Client | undefined>(undefined);

  readonly isAdmin = computed(() => this.user()?.role === Roles.Admin);
  readonly name = computed(() => `${this.user()?.firstName ?? ''} ${this.user()?.lastName ?? ''}`);
  readonly email = computed(() => this.user()?.email ?? '');
  readonly shopifyId = computed(() => this.user()?.shopifyId ?? '');

  ngOnInit(): void {
    this.sub$ = this.authService.user$.subscribe((user) => this.user.set(user as Client));
  }

  onLogout() {
    this.authService.signOut();
    this.router.navigate(RoutePath.getPath(Path['auth/signin']).fullPath);
  }

  onMenuOpened() {
    const overlay = document.querySelector('.cdk-overlay-connected-position-bounding-box');

    if (!overlay) return;

    this.render.setStyle(overlay, 'transform', 'translateX(65px) translateY(65px)');
  }
}
